<!-- <app-stanc-loader></app-stanc-loader> -->
<div class="h-100 main_wrapper">
    <div class=" h-100">
      <router-outlet></router-outlet>
    </div>    
</div>